// Cores discretas (nada de tom vibrante) pra dar uma pista visual rápida da
// modalidade sem disputar atenção com o resto da tabela. Se aparecer uma
// modalidade nova (cadastrada pelo admin) que não está aqui, cai no padrão cinza.
const MODALIDADE_COLORS: Record<string, { backgroundColor: string; color: string }> = {
    'Concorrência': { backgroundColor: '#E3F2FD', color: '#1565C0' },
    'Tomada de Preços': { backgroundColor: '#E0F2F1', color: '#00695C' },
    'Convite': { backgroundColor: '#E8F5E9', color: '#2E7D32' },
    'Concurso': { backgroundColor: '#E8EAF6', color: '#3949AB' },
    'Leilão': { backgroundColor: '#FFF3E0', color: '#E65100' },
    'Pregão': { backgroundColor: '#E3F2FD', color: '#1565C0' },
    'Dispensa': { backgroundColor: '#FFFDE7', color: '#F9A825' },
    'Chamada Pública': { backgroundColor: '#E0F7FA', color: '#00838F' },
    'Inexigibilidade': { backgroundColor: '#FFEBEE', color: '#C62828' },
    'Credenciamento': { backgroundColor: '#F3E5F5', color: '#6A1B9A' },
    'Pré-Qualificação': { backgroundColor: '#EFEBE9', color: '#4E342E' },
    'Regime Diferenciado de Contratação': { backgroundColor: '#EDE7F6', color: '#4527A0' },
};

const DEFAULT_COLOR = { backgroundColor: '#ECEFF1', color: '#455A64' };

export const getModalidadeColor = (nome?: string): { backgroundColor: string; color: string } => {
    if (!nome) return DEFAULT_COLOR;
    return MODALIDADE_COLORS[nome] || DEFAULT_COLOR;
};
